'use client';
import React from 'react';
import { getAssetUrl } from '@utils/getAssetUrl';
import TabData from '../TabData';
import cn from './style.module.scss';

export default function Sustainability(props: any) {
  const { t } = props;
  const tabContent = [
    {
      heading: t['yasTabTwoHeading'],
      description: t['yasTabTwoContent'],
      listElement: t['yasTabTwoElement'],
      images: [{ url: props.themeImg.url }],
    },
  ];
  return (
    <div
      className={cn.sustainabilityGRDWrapper}
      style={{
        backgroundImage: `url(${props.bgImg.url})`,
      }}
    >
      <TabData tabs={tabContent} />
    </div>
  );
}
